const resources = {
    title: 'Clavardage beauté IA',
    placeholder: 'Message...',
    shareFeedback: 'Partagez votre avis',
    new: 'NOUVEAUTÉ',
    addToBasket: 'Ajouter au panier',
    size: 'Format',
    errorMessage: 'Un problème est survenu. Essayez de redémarrer le clavardage ou',
    resendYourMessage: 'renvoyez votre message',
    lookingForAGift: 'Je cherche un cadeau!',
    startChat: 'Démarrez une séance de clavardage',
    tryAsking: 'Essayez de demander',
    topHairCareQuestions: 'Questions les plus fréquentes sur les soins capillaires',
    topSkincareQuestions: 'Questions les plus fréquentes sur les soins de la peau',
    topMakeupQuestions: 'Questions les plus fréquentes sur le maquillage',
    topFragranceQuestions: 'Questions les plus fréquentes sur les parfums',
    topBathBodyQuestions: 'Questions les plus fréquentes sur les essentiels pour le bain et le corps',
    description: 'Soutenu par des millions d’évaluations, des renseignements exclusifs sur les articles et vos préférences personnelles en matière de beauté.',
    feedback: 'Avis',
    added: 'Ajouté',
    free: 'GRATUIT',
    points: 'Points',
    purchasedOn: 'ACHETÉ LE',
    color: 'Couleur :',
    shade: 'Teinte :',
    variant: 'Variante :',
    viewAll: 'Tout afficher',
    fromCustomerReviews: 'D’après les évaluations de membres de la clientèle :',
    customerReviewSentiments: 'Sentiments exprimés par les commentaires des clients',
    positiveSentiment: 'Positifs',
    negativeSentiment: 'Négatifs',
    positiveReviewsMentioning: 'Commentaires positifs mentionnant',
    negativeReviewsMentioning: 'Commentaires négatifs mentionnant',
    sentimentQueryFor: 'pour',
    newChat: 'Nouvelle conversation',
    whyRecommended: 'Why this product was recommended'
};

export default function getResource(label) {
    return resources[label];
}
